module.exports = [
  {
    category: "border-radius",
    css: "--border-radius-0",
    friendly: "Border Radius 0",
    javascript: "border_radius_0",
    name: "border-radius-0",
    scss: "border-radius(0)",
    system: "0",
    type: "border-radius",
    value: "0",
  },
  {
    category: "border-radius",
    css: "--border-radius-100",
    friendly: "Border Radius 100",
    javascript: "border_radius_100",
    name: "border-radius-100",
    scss: "border-radius(100)",
    system: "100",
    type: "border-radius",
    value: "1px",
  },
  {
    category: "border-radius",
    css: "--border-radius-200",
    friendly: "Border Radius 200",
    javascript: "border_radius_200",
    name: "border-radius-200",
    scss: "border-radius(200)",
    system: "200",
    type: "border-radius",
    value: "2px",
  },
  {
    category: "border-radius",
    css: "--border-radius-pill",
    friendly: "Border Radius Pill",
    javascript: "border_radius_pill",
    name: "border-radius-pill",
    scss: "border-radius(pill)",
    system: "pill",
    type: "border-radius",
    value: "9999em",
  },
  {
    category: "border-radius",
    css: "--border-radius-circle",
    friendly: "Border Radius Circle",
    javascript: "border_radius_circle",
    name: "border-radius-circle",
    scss: "border-radius(circle)",
    system: "circle",
    type: "border-radius",
    value: "50%",
  },
  {
    category: "border-width",
    css: "--border-width-0",
    friendly: "Border Width 0",
    javascript: "border_width_0",
    name: "border-width-0",
    scss: "border-width(0)",
    system: "0",
    type: "border-width",
    value: "0",
  },
  {
    category: "border-width",
    css: "--border-width-100",
    friendly: "Border Width 100",
    javascript: "border_width_100",
    name: "border-width-100",
    scss: "border-width(100)",
    system: "100",
    type: "border-width",
    value: "1px",
  },
  {
    category: "border-width",
    css: "--border-width-200",
    friendly: "Border Width 200",
    javascript: "border_width_200",
    name: "border-width-200",
    scss: "border-width(200)",
    system: "200",
    type: "border-width",
    value: "2px",
  },
  {
    category: "color",
    css: "--color-brand-orange",
    friendly: "Color Brand Orange",
    javascript: "color_brand_orange",
    name: "color-brand-orange",
    scss: "color(brand,orange)",
    system: "brand.orange",
    type: "color",
    value: "#FA6423",
  },
  {
    category: "color",
    css: "--color-brand-gray",
    friendly: "Color Brand Gray",
    javascript: "color_brand_gray",
    name: "color-brand-gray",
    scss: "color(brand,gray)",
    system: "brand.gray",
    type: "color",
    value: "#55555A",
  },
  {
    category: "color",
    css: "--color-brand-blue",
    friendly: "Color Brand Blue",
    javascript: "color_brand_blue",
    name: "color-brand-blue",
    scss: "color(brand,blue)",
    system: "brand.blue",
    type: "color",
    value: "#37AADC",
  },
  {
    category: "color",
    css: "--color-yellow-100",
    friendly: "Color Yellow 100",
    javascript: "color_yellow_100",
    name: "color-yellow-100",
    scss: "color(yellow,100)",
    system: "yellow.100",
    type: "color",
    value: "#FFFADB",
  },
  {
    category: "color",
    css: "--color-yellow-200",
    friendly: "Color Yellow 200",
    javascript: "color_yellow_200",
    name: "color-yellow-200",
    scss: "color(yellow,200)",
    system: "yellow.200",
    type: "color",
    value: "#FFF4B5",
  },
  {
    category: "color",
    css: "--color-yellow-300",
    friendly: "Color Yellow 300",
    javascript: "color_yellow_300",
    name: "color-yellow-300",
    scss: "color(yellow,300)",
    system: "yellow.300",
    type: "color",
    value: "#FFE75C",
  },
  {
    category: "color",
    css: "--color-yellow-400",
    friendly: "Color Yellow 400",
    javascript: "color_yellow_400",
    name: "color-yellow-400",
    scss: "color(yellow,400)",
    system: "yellow.400",
    type: "color",
    value: "#FFDA00",
  },
  {
    category: "color",
    css: "--color-yellow-500",
    friendly: "Color Yellow 500",
    javascript: "color_yellow_500",
    name: "color-yellow-500",
    scss: "color(yellow,500)",
    system: "yellow.500",
    type: "color",
    value: "#E3AD0B",
  },
  {
    category: "color",
    css: "--color-yellow-600",
    friendly: "Color Yellow 600",
    javascript: "color_yellow_600",
    name: "color-yellow-600",
    scss: "color(yellow,600)",
    system: "yellow.600",
    type: "color",
    value: "#B58C12",
  },
  {
    category: "color",
    css: "--color-yellow-700",
    friendly: "Color Yellow 700",
    javascript: "color_yellow_700",
    name: "color-yellow-700",
    scss: "color(yellow,700)",
    system: "yellow.700",
    type: "color",
    value: "#876A2F",
  },
  {
    category: "color",
    css: "--color-yellow-800",
    friendly: "Color Yellow 800",
    javascript: "color_yellow_800",
    name: "color-yellow-800",
    scss: "color(yellow,800)",
    system: "yellow.800",
    type: "color",
    value: "#614D27",
  },
  {
    category: "color",
    css: "--color-yellow-900",
    friendly: "Color Yellow 900",
    javascript: "color_yellow_900",
    name: "color-yellow-900",
    scss: "color(yellow,900)",
    system: "yellow.900",
    type: "color",
    value: "#523E21",
  },
  {
    category: "color",
    css: "--color-yellow-1000",
    friendly: "Color Yellow 1000",
    javascript: "color_yellow_1000",
    name: "color-yellow-1000",
    scss: "color(yellow,1000)",
    system: "yellow.1000",
    type: "color",
    value: "#3D3121",
  },
  {
    category: "color",
    css: "--color-green-100",
    friendly: "Color Green 100",
    javascript: "color_green_100",
    name: "color-green-100",
    scss: "color(green,100)",
    system: "green.100",
    type: "color",
    value: "#E8FFF7",
  },
  {
    category: "color",
    css: "--color-green-200",
    friendly: "Color Green 200",
    javascript: "color_green_200",
    name: "color-green-200",
    scss: "color(green,200)",
    system: "green.200",
    type: "color",
    value: "#D6FFF1",
  },
  {
    category: "color",
    css: "--color-green-300",
    friendly: "Color Green 300",
    javascript: "color_green_300",
    name: "color-green-300",
    scss: "color(green,300)",
    system: "green.300",
    type: "color",
    value: "#B5F5E0",
  },
  {
    category: "color",
    css: "--color-green-400",
    friendly: "Color Green 400",
    javascript: "color_green_400",
    name: "color-green-400",
    scss: "color(green,400)",
    system: "green.400",
    type: "color",
    value: "#8DEBCB",
  },
  {
    category: "color",
    css: "--color-green-500",
    friendly: "Color Green 500",
    javascript: "color_green_500",
    name: "color-green-500",
    scss: "color(green,500)",
    system: "green.500",
    type: "color",
    value: "#52D9AC",
  },
  {
    category: "color",
    css: "--color-green-600",
    friendly: "Color Green 600",
    javascript: "color_green_600",
    name: "color-green-600",
    scss: "color(green,600)",
    system: "green.600",
    type: "color",
    value: "#28BD8B",
  },
  {
    category: "color",
    css: "--color-green-700",
    friendly: "Color Green 700",
    javascript: "color_green_700",
    name: "color-green-700",
    scss: "color(green,700)",
    system: "green.700",
    type: "color",
    value: "#009F6A",
  },
  {
    category: "color",
    css: "--color-green-800",
    friendly: "Color Green 800",
    javascript: "color_green_800",
    name: "color-green-800",
    scss: "color(green,800)",
    system: "green.800",
    type: "color",
    value: "#067852",
  },
  {
    category: "color",
    css: "--color-green-900",
    friendly: "Color Green 900",
    javascript: "color_green_900",
    name: "color-green-900",
    scss: "color(green,900)",
    system: "green.900",
    type: "color",
    value: "#1B5441",
  },
  {
    category: "color",
    css: "--color-green-1000",
    friendly: "Color Green 1000",
    javascript: "color_green_1000",
    name: "color-green-1000",
    scss: "color(green,1000)",
    system: "green.1000",
    type: "color",
    value: "#233B33",
  },
  {
    category: "color",
    css: "--color-teal-100",
    friendly: "Color Teal 100",
    javascript: "color_teal_100",
    name: "color-teal-100",
    scss: "color(teal,100)",
    system: "teal.100",
    type: "color",
    value: "#E3FFFF",
  },
  {
    category: "color",
    css: "--color-teal-200",
    friendly: "Color Teal 200",
    javascript: "color_teal_200",
    name: "color-teal-200",
    scss: "color(teal,200)",
    system: "teal.200",
    type: "color",
    value: "#CCFFFF",
  },
  {
    category: "color",
    css: "--color-teal-300",
    friendly: "Color Teal 300",
    javascript: "color_teal_300",
    name: "color-teal-300",
    scss: "color(teal,300)",
    system: "teal.300",
    type: "color",
    value: "#96FEFF",
  },
  {
    category: "color",
    css: "--color-teal-400",
    friendly: "Color Teal 400",
    javascript: "color_teal_400",
    name: "color-teal-400",
    scss: "color(teal,400)",
    system: "teal.400",
    type: "color",
    value: "#6EF4F5",
  },
  {
    category: "color",
    css: "--color-teal-500",
    friendly: "Color Teal 500",
    javascript: "color_teal_500",
    name: "color-teal-500",
    scss: "color(teal,500)",
    system: "teal.500",
    type: "color",
    value: "#37E4E6",
  },
  {
    category: "color",
    css: "--color-teal-600",
    friendly: "Color Teal 600",
    javascript: "color_teal_600",
    name: "color-teal-600",
    scss: "color(teal,600)",
    system: "teal.600",
    type: "color",
    value: "#13BEBF",
  },
  {
    category: "color",
    css: "--color-teal-700",
    friendly: "Color Teal 700",
    javascript: "color_teal_700",
    name: "color-teal-700",
    scss: "color(teal,700)",
    system: "teal.700",
    type: "color",
    value: "#199091",
  },
  {
    category: "color",
    css: "--color-teal-800",
    friendly: "Color Teal 800",
    javascript: "color_teal_800",
    name: "color-teal-800",
    scss: "color(teal,800)",
    system: "teal.800",
    type: "color",
    value: "#226363",
  },
  {
    category: "color",
    css: "--color-teal-900",
    friendly: "Color Teal 900",
    javascript: "color_teal_900",
    name: "color-teal-900",
    scss: "color(teal,900)",
    system: "teal.900",
    type: "color",
    value: "#274C4D",
  },
  {
    category: "color",
    css: "--color-teal-1000",
    friendly: "Color Teal 1000",
    javascript: "color_teal_1000",
    name: "color-teal-1000",
    scss: "color(teal,1000)",
    system: "teal.1000",
    type: "color",
    value: "#223A3B",
  },
  {
    category: "color",
    css: "--color-blue-100",
    friendly: "Color Blue 100",
    javascript: "color_blue_100",
    name: "color-blue-100",
    scss: "color(blue,100)",
    system: "blue.100",
    type: "color",
    value: "#F2F8FF",
  },
  {
    category: "color",
    css: "--color-blue-200",
    friendly: "Color Blue 200",
    javascript: "color_blue_200",
    name: "color-blue-200",
    scss: "color(blue,200)",
    system: "blue.200",
    type: "color",
    value: "#E8F3FF",
  },
  {
    category: "color",
    css: "--color-blue-300",
    friendly: "Color Blue 300",
    javascript: "color_blue_300",
    name: "color-blue-300",
    scss: "color(blue,300)",
    system: "blue.300",
    type: "color",
    value: "#CCE3FF",
  },
  {
    category: "color",
    css: "--color-blue-400",
    friendly: "Color Blue 400",
    javascript: "color_blue_400",
    name: "color-blue-400",
    scss: "color(blue,400)",
    system: "blue.400",
    type: "color",
    value: "#ABD2FF",
  },
  {
    category: "color",
    css: "--color-blue-500",
    friendly: "Color Blue 500",
    javascript: "color_blue_500",
    name: "color-blue-500",
    scss: "color(blue,500)",
    system: "blue.500",
    type: "color",
    value: "#78B6FF",
  },
  {
    category: "color",
    css: "--color-blue-600",
    friendly: "Color Blue 600",
    javascript: "color_blue_600",
    name: "color-blue-600",
    scss: "color(blue,600)",
    system: "blue.600",
    type: "color",
    value: "#429BFF",
  },
  {
    category: "color",
    css: "--color-blue-700",
    friendly: "Color Blue 700",
    javascript: "color_blue_700",
    name: "color-blue-700",
    scss: "color(blue,700)",
    system: "blue.700",
    type: "color",
    value: "#1273E6",
  },
  {
    category: "color",
    css: "--color-blue-800",
    friendly: "Color Blue 800",
    javascript: "color_blue_800",
    name: "color-blue-800",
    scss: "color(blue,800)",
    system: "blue.800",
    type: "color",
    value: "#0060CC",
  },
  {
    category: "color",
    css: "--color-blue-900",
    friendly: "Color Blue 900",
    javascript: "color_blue_900",
    name: "color-blue-900",
    scss: "color(blue,900)",
    system: "blue.900",
    type: "color",
    value: "#1A497D",
  },
  {
    category: "color",
    css: "--color-blue-1000",
    friendly: "Color Blue 1000",
    javascript: "color_blue_1000",
    name: "color-blue-1000",
    scss: "color(blue,1000)",
    system: "blue.1000",
    type: "color",
    value: "#203752",
  },
  {
    category: "color",
    css: "--color-purple-100",
    friendly: "Color Purple 100",
    javascript: "color_purple_100",
    name: "color-purple-100",
    scss: "color(purple,100)",
    system: "purple.100",
    type: "color",
    value: "#F9F5FF",
  },
  {
    category: "color",
    css: "--color-purple-200",
    friendly: "Color Purple 200",
    javascript: "color_purple_200",
    name: "color-purple-200",
    scss: "color(purple,200)",
    system: "purple.200",
    type: "color",
    value: "#F3EBFF",
  },
  {
    category: "color",
    css: "--color-purple-300",
    friendly: "Color Purple 300",
    javascript: "color_purple_300",
    name: "color-purple-300",
    scss: "color(purple,300)",
    system: "purple.300",
    type: "color",
    value: "#E5D4FF",
  },
  {
    category: "color",
    css: "--color-purple-400",
    friendly: "Color Purple 400",
    javascript: "color_purple_400",
    name: "color-purple-400",
    scss: "color(purple,400)",
    system: "purple.400",
    type: "color",
    value: "#D7BDFF",
  },
  {
    category: "color",
    css: "--color-purple-500",
    friendly: "Color Purple 500",
    javascript: "color_purple_500",
    name: "color-purple-500",
    scss: "color(purple,500)",
    system: "purple.500",
    type: "color",
    value: "#BD91FF",
  },
  {
    category: "color",
    css: "--color-purple-600",
    friendly: "Color Purple 600",
    javascript: "color_purple_600",
    name: "color-purple-600",
    scss: "color(purple,600)",
    system: "purple.600",
    type: "color",
    value: "#A469FF",
  },
  {
    category: "color",
    css: "--color-purple-700",
    friendly: "Color Purple 700",
    javascript: "color_purple_700",
    name: "color-purple-700",
    scss: "color(purple,700)",
    system: "purple.700",
    type: "color",
    value: "#8C40FF",
  },
  {
    category: "color",
    css: "--color-purple-800",
    friendly: "Color Purple 800",
    javascript: "color_purple_800",
    name: "color-purple-800",
    scss: "color(purple,800)",
    system: "purple.800",
    type: "color",
    value: "#7122E3",
  },
  {
    category: "color",
    css: "--color-purple-900",
    friendly: "Color Purple 900",
    javascript: "color_purple_900",
    name: "color-purple-900",
    scss: "color(purple,900)",
    system: "purple.900",
    type: "color",
    value: "#4C2E87",
  },
  {
    category: "color",
    css: "--color-purple-1000",
    friendly: "Color Purple 1000",
    javascript: "color_purple_1000",
    name: "color-purple-1000",
    scss: "color(purple,1000)",
    system: "purple.1000",
    type: "color",
    value: "#352E4A",
  },
  {
    category: "color",
    css: "--color-magenta-100",
    friendly: "Color Magenta 100",
    javascript: "color_magenta_100",
    name: "color-magenta-100",
    scss: "color(magenta,100)",
    system: "magenta.100",
    type: "color",
    value: "#FFF2F8",
  },
  {
    category: "color",
    css: "--color-magenta-200",
    friendly: "Color Magenta 200",
    javascript: "color_magenta_200",
    name: "color-magenta-200",
    scss: "color(magenta,200)",
    system: "magenta.200",
    type: "color",
    value: "#FFE8F2",
  },
  {
    category: "color",
    css: "--color-magenta-300",
    friendly: "Color Magenta 300",
    javascript: "color_magenta_300",
    name: "color-magenta-300",
    scss: "color(magenta,300)",
    system: "magenta.300",
    type: "color",
    value: "#FFCCE3",
  },
  {
    category: "color",
    css: "--color-magenta-400",
    friendly: "Color Magenta 400",
    javascript: "color_magenta_400",
    name: "color-magenta-400",
    scss: "color(magenta,400)",
    system: "magenta.400",
    type: "color",
    value: "#FFB0D3",
  },
  {
    category: "color",
    css: "--color-magenta-500",
    friendly: "Color Magenta 500",
    javascript: "color_magenta_500",
    name: "color-magenta-500",
    scss: "color(magenta,500)",
    system: "magenta.500",
    type: "color",
    value: "#FF7DB7",
  },
  {
    category: "color",
    css: "--color-magenta-600",
    friendly: "Color Magenta 600",
    javascript: "color_magenta_600",
    name: "color-magenta-600",
    scss: "color(magenta,600)",
    system: "magenta.600",
    type: "color",
    value: "#F0549A",
  },
  {
    category: "color",
    css: "--color-magenta-700",
    friendly: "Color Magenta 700",
    javascript: "color_magenta_700",
    name: "color-magenta-700",
    scss: "color(magenta,700)",
    system: "magenta.700",
    type: "color",
    value: "#D1347A",
  },
  {
    category: "color",
    css: "--color-magenta-800",
    friendly: "Color Magenta 800",
    javascript: "color_magenta_800",
    name: "color-magenta-800",
    scss: "color(magenta,800)",
    system: "magenta.800",
    type: "color",
    value: "#992659",
  },
  {
    category: "color",
    css: "--color-magenta-900",
    friendly: "Color Magenta 900",
    javascript: "color_magenta_900",
    name: "color-magenta-900",
    scss: "color(magenta,900)",
    system: "magenta.900",
    type: "color",
    value: "#782449",
  },
  {
    category: "color",
    css: "--color-magenta-1000",
    friendly: "Color Magenta 1000",
    javascript: "color_magenta_1000",
    name: "color-magenta-1000",
    scss: "color(magenta,1000)",
    system: "magenta.1000",
    type: "color",
    value: "#522338",
  },
  {
    category: "color",
    css: "--color-red-100",
    friendly: "Color Red 100",
    javascript: "color_red_100",
    name: "color-red-100",
    scss: "color(red,100)",
    system: "red.100",
    type: "color",
    value: "#FFF2F3",
  },
  {
    category: "color",
    css: "--color-red-200",
    friendly: "Color Red 200",
    javascript: "color_red_200",
    name: "color-red-200",
    scss: "color(red,200)",
    system: "red.200",
    type: "color",
    value: "#FFEBEC",
  },
  {
    category: "color",
    css: "--color-red-300",
    friendly: "Color Red 300",
    javascript: "color_red_300",
    name: "color-red-300",
    scss: "color(red,300)",
    system: "red.300",
    type: "color",
    value: "#FFCFD1",
  },
  {
    category: "color",
    css: "--color-red-400",
    friendly: "Color Red 400",
    javascript: "color_red_400",
    name: "color-red-400",
    scss: "color(red,400)",
    system: "red.400",
    type: "color",
    value: "#FFB5B9",
  },
  {
    category: "color",
    css: "--color-red-500",
    friendly: "Color Red 500",
    javascript: "color_red_500",
    name: "color-red-500",
    scss: "color(red,500)",
    system: "red.500",
    type: "color",
    value: "#FF858B",
  },
  {
    category: "color",
    css: "--color-red-600",
    friendly: "Color Red 600",
    javascript: "color_red_600",
    name: "color-red-600",
    scss: "color(red,600)",
    system: "red.600",
    type: "color",
    value: "#FF5760",
  },
  {
    category: "color",
    css: "--color-red-700",
    friendly: "Color Red 700",
    javascript: "color_red_700",
    name: "color-red-700",
    scss: "color(red,700)",
    system: "red.700",
    type: "color",
    value: "#D9363E",
  },
  {
    category: "color",
    css: "--color-red-800",
    friendly: "Color Red 800",
    javascript: "color_red_800",
    name: "color-red-800",
    scss: "color(red,800)",
    system: "red.800",
    type: "color",
    value: "#A12B2B",
  },
  {
    category: "color",
    css: "--color-red-900",
    friendly: "Color Red 900",
    javascript: "color_red_900",
    name: "color-red-900",
    scss: "color(red,900)",
    system: "red.900",
    type: "color",
    value: "#80252A",
  },
  {
    category: "color",
    css: "--color-red-1000",
    friendly: "Color Red 1000",
    javascript: "color_red_1000",
    name: "color-red-1000",
    scss: "color(red,1000)",
    system: "red.1000",
    type: "color",
    value: "#5C2121",
  },
  {
    category: "color",
    css: "--color-gray-100",
    friendly: "Color Gray 100",
    javascript: "color_gray_100",
    name: "color-gray-100",
    scss: "color(gray,100)",
    system: "gray.100",
    type: "color",
    value: "#F5F8FA",
  },
  {
    category: "color",
    css: "--color-gray-200",
    friendly: "Color Gray 200",
    javascript: "color_gray_200",
    name: "color-gray-200",
    scss: "color(gray,200)",
    system: "gray.200",
    type: "color",
    value: "#EBF0F5",
  },
  {
    category: "color",
    css: "--color-gray-300",
    friendly: "Color Gray 300",
    javascript: "color_gray_300",
    name: "color-gray-300",
    scss: "color(gray,300)",
    system: "gray.300",
    type: "color",
    value: "#D9E0E6",
  },
  {
    category: "color",
    css: "--color-gray-400",
    friendly: "Color Gray 400",
    javascript: "color_gray_400",
    name: "color-gray-400",
    scss: "color(gray,400)",
    system: "gray.400",
    type: "color",
    value: "#C5CED6",
  },
  {
    category: "color",
    css: "--color-gray-500",
    friendly: "Color Gray 500",
    javascript: "color_gray_500",
    name: "color-gray-500",
    scss: "color(gray,500)",
    system: "gray.500",
    type: "color",
    value: "#A2ADB8",
  },
  {
    category: "color",
    css: "--color-gray-600",
    friendly: "Color Gray 600",
    javascript: "color_gray_600",
    name: "color-gray-600",
    scss: "color(gray,600)",
    system: "gray.600",
    type: "color",
    value: "#818E9A",
  },
  {
    category: "color",
    css: "--color-gray-700",
    friendly: "Color Gray 700",
    javascript: "color_gray_700",
    name: "color-gray-700",
    scss: "color(gray,700)",
    system: "gray.700",
    type: "color",
    value: "#626F7A",
  },
  {
    category: "color",
    css: "--color-gray-800",
    friendly: "Color Gray 800",
    javascript: "color_gray_800",
    name: "color-gray-800",
    scss: "color(gray,800)",
    system: "gray.800",
    type: "color",
    value: "#46525C",
  },
  {
    category: "color",
    css: "--color-gray-900",
    friendly: "Color Gray 900",
    javascript: "color_gray_900",
    name: "color-gray-900",
    scss: "color(gray,900)",
    system: "gray.900",
    type: "color",
    value: "#39444D",
  },
  {
    category: "color",
    css: "--color-gray-1000",
    friendly: "Color Gray 1000",
    javascript: "color_gray_1000",
    name: "color-gray-1000",
    scss: "color(gray,1000)",
    system: "gray.1000",
    type: "color",
    value: "#2C353D",
  },
  {
    category: "color",
    css: "--color-white",
    friendly: "Color White",
    javascript: "color_white",
    name: "color-white",
    scss: "color(white)",
    system: "white",
    type: "color",
    value: "#FFFFFF",
  },
  {
    category: "box-shadow",
    css: "--box-shadow-0",
    friendly: "Box Shadow 0",
    javascript: "box_shadow_0",
    name: "box-shadow-0",
    scss: "box-shadow(0)",
    system: "0",
    type: "box-shadow",
    value: "none",
  },
  {
    category: "box-shadow",
    css: "--box-shadow-100",
    friendly: "Box Shadow 100",
    javascript: "box_shadow_100",
    name: "box-shadow-100",
    scss: "box-shadow(100)",
    system: "100",
    type: "box-shadow",
    value: "0px 1px 2px rgba(44,53,61,.2)",
  },
  {
    category: "box-shadow",
    css: "--box-shadow-200",
    friendly: "Box Shadow 200",
    javascript: "box_shadow_200",
    name: "box-shadow-200",
    scss: "box-shadow(200)",
    system: "200",
    type: "box-shadow",
    value: "0px 2px 4px rgba(44,53,61,.2)",
  },
  {
    category: "box-shadow",
    css: "--box-shadow-300",
    friendly: "Box Shadow 300",
    javascript: "box_shadow_300",
    name: "box-shadow-300",
    scss: "box-shadow(300)",
    system: "300",
    type: "box-shadow",
    value: "0px 4px 8px rgba(44,53,61,.2)",
  },
  {
    category: "box-shadow",
    css: "--box-shadow-400",
    friendly: "Box Shadow 400",
    javascript: "box_shadow_400",
    name: "box-shadow-400",
    scss: "box-shadow(400)",
    system: "400",
    type: "box-shadow",
    value: "0px 8px 16px rgba(44,53,61,.2)",
  },
  {
    category: "z-index",
    css: "--z-index-auto",
    friendly: "Z Index Auto",
    javascript: "z_index_auto",
    name: "z-index-auto",
    scss: "z-index(auto)",
    system: "auto",
    type: "z-index",
    value: "auto",
  },
  {
    category: "z-index",
    css: "--z-index-below",
    friendly: "Z Index Below",
    javascript: "z_index_below",
    name: "z-index-below",
    scss: "z-index(below)",
    system: "below",
    type: "z-index",
    value: "-1",
  },
  {
    category: "z-index",
    css: "--z-index-default",
    friendly: "Z Index Default",
    javascript: "z_index_default",
    name: "z-index-default",
    scss: "z-index(default)",
    system: "default",
    type: "z-index",
    value: "1",
  },
  {
    category: "z-index",
    css: "--z-index-above",
    friendly: "Z Index Above",
    javascript: "z_index_above",
    name: "z-index-above",
    scss: "z-index(above)",
    system: "above",
    type: "z-index",
    value: "10",
  },
  {
    category: "z-index",
    css: "--z-index-overlay",
    friendly: "Z Index Overlay",
    javascript: "z_index_overlay",
    name: "z-index-overlay",
    scss: "z-index(overlay)",
    system: "overlay",
    type: "z-index",
    value: "1000",
  },
  {
    category: "font-family",
    css: "--font-family-sans",
    friendly: "Font Family Sans",
    javascript: "font_family_sans",
    name: "font-family-sans",
    scss: "font-family(sans)",
    system: "sans",
    type: "font-family",
    value:
      "'Calibre', -apple-system, BlinkMacSystemFont, 'San Francisco', 'Segoe UI', Roboto, Helvetica, sans-serif",
  },
  {
    category: "font-family",
    css: "--font-family-monospace",
    friendly: "Font Family Monospace",
    javascript: "font_family_monospace",
    name: "font-family-monospace",
    scss: "font-family(monospace)",
    system: "monospace",
    type: "font-family",
    value: "'SFMono-Regular', Monaco, Consolas, 'Lucida Console', monospace",
  },
  {
    category: "line-height",
    css: "--line-height-100",
    friendly: "Line Height 100",
    javascript: "line_height_100",
    name: "line-height-100",
    pixel_value: "16px",
    pixel_value_unitless: "16",
    scss: "line-height(100)",
    system: "100",
    type: "line-height",
    value: "1rem",
  },
  {
    category: "line-height",
    css: "--line-height-200",
    friendly: "Line Height 200",
    javascript: "line_height_200",
    name: "line-height-200",
    pixel_value: "20px",
    pixel_value_unitless: "20",
    scss: "line-height(200)",
    system: "200",
    type: "line-height",
    value: "1.25rem",
  },
  {
    category: "line-height",
    css: "--line-height-300",
    friendly: "Line Height 300",
    javascript: "line_height_300",
    name: "line-height-300",
    pixel_value: "24px",
    pixel_value_unitless: "24",
    scss: "line-height(300)",
    system: "300",
    type: "line-height",
    value: "1.5rem",
  },
  {
    category: "line-height",
    css: "--line-height-400",
    friendly: "Line Height 400",
    javascript: "line_height_400",
    name: "line-height-400",
    pixel_value: "28px",
    pixel_value_unitless: "28",
    scss: "line-height(400)",
    system: "400",
    type: "line-height",
    value: "1.750rem",
  },
  {
    category: "line-height",
    css: "--line-height-500",
    friendly: "Line Height 500",
    javascript: "line_height_500",
    name: "line-height-500",
    pixel_value: "32px",
    pixel_value_unitless: "32",
    scss: "line-height(500)",
    system: "500",
    type: "line-height",
    value: "2rem",
  },
  {
    category: "line-height",
    css: "--line-height-600",
    friendly: "Line Height 600",
    javascript: "line_height_600",
    name: "line-height-600",
    pixel_value: "40px",
    pixel_value_unitless: "40",
    scss: "line-height(600)",
    system: "600",
    type: "line-height",
    value: "2.5rem",
  },
  {
    category: "line-height",
    css: "--line-height-700",
    friendly: "Line Height 700",
    javascript: "line_height_700",
    name: "line-height-700",
    pixel_value: "56px",
    pixel_value_unitless: "56",
    scss: "line-height(700)",
    system: "700",
    type: "line-height",
    value: "3.5rem",
  },
  {
    category: "line-height",
    css: "--line-height-800",
    friendly: "Line Height 800",
    javascript: "line_height_800",
    name: "line-height-800",
    pixel_value: "68px",
    pixel_value_unitless: "68",
    scss: "line-height(800)",
    system: "800",
    type: "line-height",
    value: "4.25rem",
  },
  {
    category: "font-size",
    css: "--font-size-50",
    friendly: "Font Size 50",
    javascript: "font_size_50",
    name: "font-size-50",
    pixel_value: "12px",
    pixel_value_unitless: "12",
    scss: "font-size(50)",
    system: "50",
    type: "font-size",
    value: "0.75rem",
  },
  {
    category: "font-size",
    css: "--font-size-100",
    friendly: "Font Size 100",
    javascript: "font_size_100",
    name: "font-size-100",
    pixel_value: "14px",
    pixel_value_unitless: "14",
    scss: "font-size(100)",
    system: "100",
    type: "font-size",
    value: "0.875rem",
  },
  {
    category: "font-size",
    css: "--font-size-200",
    friendly: "Font Size 200",
    javascript: "font_size_200",
    name: "font-size-200",
    pixel_value: "16px",
    pixel_value_unitless: "16",
    scss: "font-size(200)",
    system: "200",
    type: "font-size",
    value: "1rem",
  },
  {
    category: "font-size",
    css: "--font-size-300",
    friendly: "Font Size 300",
    javascript: "font_size_300",
    name: "font-size-300",
    pixel_value: "18px",
    pixel_value_unitless: "18",
    scss: "font-size(300)",
    system: "300",
    type: "font-size",
    value: "1.125rem",
  },
  {
    category: "font-size",
    css: "--font-size-400",
    friendly: "Font Size 400",
    javascript: "font_size_400",
    name: "font-size-400",
    pixel_value: "20px",
    pixel_value_unitless: "20",
    scss: "font-size(400)",
    system: "400",
    type: "font-size",
    value: "1.25rem",
  },
  {
    category: "font-size",
    css: "--font-size-500",
    friendly: "Font Size 500",
    javascript: "font_size_500",
    name: "font-size-500",
    pixel_value: "24px",
    pixel_value_unitless: "24",
    scss: "font-size(500)",
    system: "500",
    type: "font-size",
    value: "1.5rem",
  },
  {
    category: "font-size",
    css: "--font-size-600",
    friendly: "Font Size 600",
    javascript: "font_size_600",
    name: "font-size-600",
    pixel_value: "32px",
    pixel_value_unitless: "32",
    scss: "font-size(600)",
    system: "600",
    type: "font-size",
    value: "2rem",
  },
  {
    category: "font-size",
    css: "--font-size-700",
    friendly: "Font Size 700",
    javascript: "font_size_700",
    name: "font-size-700",
    pixel_value: "44px",
    pixel_value_unitless: "44",
    scss: "font-size(700)",
    system: "700",
    type: "font-size",
    value: "2.75rem",
  },
  {
    category: "font-size",
    css: "--font-size-800",
    friendly: "Font Size 800",
    javascript: "font_size_800",
    name: "font-size-800",
    pixel_value: "56px",
    pixel_value_unitless: "56",
    scss: "font-size(800)",
    system: "800",
    type: "font-size",
    value: "3.5rem",
  },
  {
    category: "font-size",
    css: "--font-size-root",
    friendly: "Font Size Root",
    javascript: "font_size_root",
    name: "font-size-root",
    scss: "font-size(root)",
    system: "root",
    type: "font-size",
    value: "16px",
  },
  {
    category: "font-weight",
    css: "--font-weight-light",
    friendly: "Font Weight Light",
    javascript: "font_weight_light",
    name: "font-weight-light",
    scss: "font-weight(light)",
    system: "light",
    type: "font-weight",
    value: "300",
  },
  {
    category: "font-weight",
    css: "--font-weight-normal",
    friendly: "Font Weight Normal",
    javascript: "font_weight_normal",
    name: "font-weight-normal",
    scss: "font-weight(normal)",
    system: "normal",
    type: "font-weight",
    value: "400",
  },
  {
    category: "font-weight",
    css: "--font-weight-medium",
    friendly: "Font Weight Medium",
    javascript: "font_weight_medium",
    name: "font-weight-medium",
    scss: "font-weight(medium)",
    system: "medium",
    type: "font-weight",
    value: "500",
  },
  {
    category: "font-weight",
    css: "--font-weight-semibold",
    friendly: "Font Weight Semibold",
    javascript: "font_weight_semibold",
    name: "font-weight-semibold",
    scss: "font-weight(semibold)",
    system: "semibold",
    type: "font-weight",
    value: "600",
  },
  {
    category: "media-query",
    css: "--media-query-xs",
    friendly: "Media Query Xs",
    javascript: "media_query_xs",
    name: "media-query-xs",
    scss: "media-query(xs)",
    system: "xs",
    type: "media-query",
    value: "448px",
  },
  {
    category: "media-query",
    css: "--media-query-sm",
    friendly: "Media Query Sm",
    javascript: "media_query_sm",
    name: "media-query-sm",
    scss: "media-query(sm)",
    system: "sm",
    type: "media-query",
    value: "720px",
  },
  {
    category: "media-query",
    css: "--media-query-md",
    friendly: "Media Query Md",
    javascript: "media_query_md",
    name: "media-query-md",
    scss: "media-query(md)",
    system: "md",
    type: "media-query",
    value: "960px",
  },
  {
    category: "media-query",
    css: "--media-query-lg",
    friendly: "Media Query Lg",
    javascript: "media_query_lg",
    name: "media-query-lg",
    scss: "media-query(lg)",
    system: "lg",
    type: "media-query",
    value: "1200px",
  },
  {
    category: "media-query",
    css: "--media-query-xl",
    friendly: "Media Query Xl",
    javascript: "media_query_xl",
    name: "media-query-xl",
    scss: "media-query(xl)",
    system: "xl",
    type: "media-query",
    value: "1440px",
  },
  {
    category: "motion-duration",
    css: "--motion-duration-fast",
    friendly: "Motion Duration Fast",
    javascript: "motion_duration_fast",
    name: "motion-duration-fast",
    scss: "motion-duration(fast)",
    system: "fast",
    type: "motion-duration",
    value: "0.15s",
  },
  {
    category: "motion-duration",
    css: "--motion-duration-medium",
    friendly: "Motion Duration Medium",
    javascript: "motion_duration_medium",
    name: "motion-duration-medium",
    scss: "motion-duration(medium)",
    system: "medium",
    type: "motion-duration",
    value: "0.3s",
  },
  {
    category: "motion-duration",
    css: "--motion-duration-slow",
    friendly: "Motion Duration Slow",
    javascript: "motion_duration_slow",
    name: "motion-duration-slow",
    scss: "motion-duration(slow)",
    system: "slow",
    type: "motion-duration",
    value: "0.7s",
  },
  {
    category: "motion-ease",
    css: "--motion-ease-in",
    friendly: "Motion Ease In",
    javascript: "motion_ease_in",
    name: "motion-ease-in",
    scss: "motion-ease(in)",
    system: "in",
    type: "motion-ease",
    value: "cubic-bezier(.35, 0, .7, .2)",
  },
  {
    category: "motion-ease",
    css: "--motion-ease-out",
    friendly: "Motion Ease Out",
    javascript: "motion_ease_out",
    name: "motion-ease-out",
    scss: "motion-ease(out)",
    system: "out",
    type: "motion-ease",
    value: "cubic-bezier(0, 0, .3, 1)",
  },
  {
    category: "motion-ease",
    css: "--motion-ease-in-out",
    friendly: "Motion Ease In-out",
    javascript: "motion_ease_in_out",
    name: "motion-ease-in-out",
    scss: "motion-ease(in-out)",
    system: "in-out",
    type: "motion-ease",
    value: "cubic-bezier(.4, 0, .3, 1)",
  },
  {
    category: "sizing",
    css: "--sizing-0",
    friendly: "Sizing 0",
    javascript: "sizing_0",
    name: "sizing-0",
    pixel_value: "0px",
    pixel_value_unitless: "0",
    scss: "sizing(0)",
    system: "0",
    type: "sizing",
    value: "0rem",
  },
  {
    category: "sizing",
    css: "--sizing-100",
    friendly: "Sizing 100",
    javascript: "sizing_100",
    name: "sizing-100",
    pixel_value: "4px",
    pixel_value_unitless: "4",
    scss: "sizing(100)",
    system: "100",
    type: "sizing",
    value: "0.25rem",
  },
  {
    category: "sizing",
    css: "--sizing-200",
    friendly: "Sizing 200",
    javascript: "sizing_200",
    name: "sizing-200",
    pixel_value: "8px",
    pixel_value_unitless: "8",
    scss: "sizing(200)",
    system: "200",
    type: "sizing",
    value: "0.5rem",
  },
  {
    category: "sizing",
    css: "--sizing-300",
    friendly: "Sizing 300",
    javascript: "sizing_300",
    name: "sizing-300",
    pixel_value: "12px",
    pixel_value_unitless: "12",
    scss: "sizing(300)",
    system: "300",
    type: "sizing",
    value: "0.75rem",
  },
  {
    category: "sizing",
    css: "--sizing-400",
    friendly: "Sizing 400",
    javascript: "sizing_400",
    name: "sizing-400",
    pixel_value: "16px",
    pixel_value_unitless: "16",
    scss: "sizing(400)",
    system: "400",
    type: "sizing",
    value: "1rem",
  },
  {
    category: "sizing",
    css: "--sizing-450",
    friendly: "Sizing 450",
    javascript: "sizing_450",
    name: "sizing-450",
    pixel_value: "20px",
    pixel_value_unitless: "20",
    scss: "sizing(450)",
    system: "450",
    type: "sizing",
    value: "1.25rem",
  },
  {
    category: "sizing",
    css: "--sizing-500",
    friendly: "Sizing 500",
    javascript: "sizing_500",
    name: "sizing-500",
    pixel_value: "24px",
    pixel_value_unitless: "24",
    scss: "sizing(500)",
    system: "500",
    type: "sizing",
    value: "1.5rem",
  },
  {
    category: "sizing",
    css: "--sizing-550",
    friendly: "Sizing 550",
    javascript: "sizing_550",
    name: "sizing-550",
    pixel_value: "28px",
    pixel_value_unitless: "28",
    scss: "sizing(550)",
    system: "550",
    type: "sizing",
    value: "1.75rem",
  },
  {
    category: "sizing",
    css: "--sizing-600",
    friendly: "Sizing 600",
    javascript: "sizing_600",
    name: "sizing-600",
    pixel_value: "32px",
    pixel_value_unitless: "32",
    scss: "sizing(600)",
    system: "600",
    type: "sizing",
    value: "2rem",
  },
  {
    category: "sizing",
    css: "--sizing-650",
    friendly: "Sizing 650",
    javascript: "sizing_650",
    name: "sizing-650",
    pixel_value: "40px",
    pixel_value_unitless: "40",
    scss: "sizing(650)",
    system: "650",
    type: "sizing",
    value: "2.5rem",
  },
  {
    category: "sizing",
    css: "--sizing-700",
    friendly: "Sizing 700",
    javascript: "sizing_700",
    name: "sizing-700",
    pixel_value: "48px",
    pixel_value_unitless: "48",
    scss: "sizing(700)",
    system: "700",
    type: "sizing",
    value: "3rem",
  },
  {
    category: "sizing",
    css: "--sizing-750",
    friendly: "Sizing 750",
    javascript: "sizing_750",
    name: "sizing-750",
    pixel_value: "56px",
    pixel_value_unitless: "56",
    scss: "sizing(750)",
    system: "750",
    type: "sizing",
    value: "3.5rem",
  },
  {
    category: "sizing",
    css: "--sizing-800",
    friendly: "Sizing 800",
    javascript: "sizing_800",
    name: "sizing-800",
    pixel_value: "64px",
    pixel_value_unitless: "64",
    scss: "sizing(800)",
    system: "800",
    type: "sizing",
    value: "4rem",
  },
  {
    category: "sizing",
    css: "--sizing-850",
    friendly: "Sizing 850",
    javascript: "sizing_850",
    name: "sizing-850",
    pixel_value: "96px",
    pixel_value_unitless: "96",
    scss: "sizing(850)",
    system: "850",
    type: "sizing",
    value: "6rem",
  },
  {
    category: "sizing",
    css: "--sizing-900",
    friendly: "Sizing 900",
    javascript: "sizing_900",
    name: "sizing-900",
    pixel_value: "160px",
    pixel_value_unitless: "160",
    scss: "sizing(900)",
    system: "900",
    type: "sizing",
    value: "10rem",
  },
  {
    category: "sizing",
    css: "--sizing-1000",
    friendly: "Sizing 1000",
    javascript: "sizing_1000",
    name: "sizing-1000",
    pixel_value: "320px",
    pixel_value_unitless: "320",
    scss: "sizing(1000)",
    system: "1000",
    type: "sizing",
    value: "20rem",
  },
  {
    category: "sizing",
    css: "--sizing-1100",
    friendly: "Sizing 1100",
    javascript: "sizing_1100",
    name: "sizing-1100",
    pixel_value: "448px",
    pixel_value_unitless: "448",
    scss: "sizing(1100)",
    system: "1100",
    type: "sizing",
    value: "28rem",
  },
  {
    category: "sizing",
    css: "--sizing-1150",
    friendly: "Sizing 1150",
    javascript: "sizing_1150",
    name: "sizing-1150",
    pixel_value: "560px",
    pixel_value_unitless: "560",
    scss: "sizing(1150)",
    system: "1150",
    type: "sizing",
    value: "35rem",
  },
  {
    category: "sizing",
    css: "--sizing-1200",
    friendly: "Sizing 1200",
    javascript: "sizing_1200",
    name: "sizing-1200",
    pixel_value: "720px",
    pixel_value_unitless: "720",
    scss: "sizing(1200)",
    system: "1200",
    type: "sizing",
    value: "45rem",
  },
  {
    category: "sizing",
    css: "--sizing-1300",
    friendly: "Sizing 1300",
    javascript: "sizing_1300",
    name: "sizing-1300",
    pixel_value: "960px",
    pixel_value_unitless: "960",
    scss: "sizing(1300)",
    system: "1300",
    type: "sizing",
    value: "60rem",
  },
  {
    category: "sizing",
    css: "--sizing-1350",
    friendly: "Sizing 1350",
    javascript: "sizing_1350",
    name: "sizing-1350",
    pixel_value: "1056px",
    pixel_value_unitless: "1056",
    scss: "sizing(1350)",
    system: "1350",
    type: "sizing",
    value: "66rem",
  },
  {
    category: "sizing",
    css: "--sizing-1400",
    friendly: "Sizing 1400",
    javascript: "sizing_1400",
    name: "sizing-1400",
    pixel_value: "1200px",
    pixel_value_unitless: "1200",
    scss: "sizing(1400)",
    system: "1400",
    type: "sizing",
    value: "75rem",
  },
  {
    category: "sizing",
    css: "--sizing-1500",
    friendly: "Sizing 1500",
    javascript: "sizing_1500",
    name: "sizing-1500",
    pixel_value: "1440px",
    pixel_value_unitless: "1440",
    scss: "sizing(1500)",
    system: "1500",
    type: "sizing",
    value: "90rem",
  },
  {
    category: "spacing",
    css: "--spacing-0",
    friendly: "Spacing 0",
    javascript: "spacing_0",
    name: "spacing-0",
    pixel_value: "0px",
    pixel_value_unitless: "0",
    scss: "spacing(0)",
    system: "0",
    type: "spacing",
    value: "0rem",
  },
  {
    category: "spacing",
    css: "--spacing-100",
    friendly: "Spacing 100",
    javascript: "spacing_100",
    name: "spacing-100",
    pixel_value: "4px",
    pixel_value_unitless: "4",
    scss: "spacing(100)",
    system: "100",
    type: "spacing",
    value: "0.25rem",
  },
  {
    category: "spacing",
    css: "--spacing-200",
    friendly: "Spacing 200",
    javascript: "spacing_200",
    name: "spacing-200",
    pixel_value: "8px",
    pixel_value_unitless: "8",
    scss: "spacing(200)",
    system: "200",
    type: "spacing",
    value: "0.5rem",
  },
  {
    category: "spacing",
    css: "--spacing-300",
    friendly: "Spacing 300",
    javascript: "spacing_300",
    name: "spacing-300",
    pixel_value: "12px",
    pixel_value_unitless: "12",
    scss: "spacing(300)",
    system: "300",
    type: "spacing",
    value: "0.75rem",
  },
  {
    category: "spacing",
    css: "--spacing-400",
    friendly: "Spacing 400",
    javascript: "spacing_400",
    name: "spacing-400",
    pixel_value: "16px",
    pixel_value_unitless: "16",
    scss: "spacing(400)",
    system: "400",
    type: "spacing",
    value: "1rem",
  },
  {
    category: "spacing",
    css: "--spacing-450",
    friendly: "Spacing 450",
    javascript: "spacing_450",
    name: "spacing-450",
    pixel_value: "20px",
    pixel_value_unitless: "20",
    scss: "spacing(450)",
    system: "450",
    type: "spacing",
    value: "1.25rem",
  },
  {
    category: "spacing",
    css: "--spacing-500",
    friendly: "Spacing 500",
    javascript: "spacing_500",
    name: "spacing-500",
    pixel_value: "24px",
    pixel_value_unitless: "24",
    scss: "spacing(500)",
    system: "500",
    type: "spacing",
    value: "1.5rem",
  },
  {
    category: "spacing",
    css: "--spacing-550",
    friendly: "Spacing 550",
    javascript: "spacing_550",
    name: "spacing-550",
    pixel_value: "28px",
    pixel_value_unitless: "28",
    scss: "spacing(550)",
    system: "550",
    type: "spacing",
    value: "1.75rem",
  },
  {
    category: "spacing",
    css: "--spacing-600",
    friendly: "Spacing 600",
    javascript: "spacing_600",
    name: "spacing-600",
    pixel_value: "32px",
    pixel_value_unitless: "32",
    scss: "spacing(600)",
    system: "600",
    type: "spacing",
    value: "2rem",
  },
  {
    category: "spacing",
    css: "--spacing-650",
    friendly: "Spacing 650",
    javascript: "spacing_650",
    name: "spacing-650",
    pixel_value: "40px",
    pixel_value_unitless: "40",
    scss: "spacing(650)",
    system: "650",
    type: "spacing",
    value: "2.5rem",
  },
  {
    category: "spacing",
    css: "--spacing-700",
    friendly: "Spacing 700",
    javascript: "spacing_700",
    name: "spacing-700",
    pixel_value: "48px",
    pixel_value_unitless: "48",
    scss: "spacing(700)",
    system: "700",
    type: "spacing",
    value: "3rem",
  },
  {
    category: "spacing",
    css: "--spacing-750",
    friendly: "Spacing 750",
    javascript: "spacing_750",
    name: "spacing-750",
    pixel_value: "56px",
    pixel_value_unitless: "56",
    scss: "spacing(750)",
    system: "750",
    type: "spacing",
    value: "3.5rem",
  },
  {
    category: "spacing",
    css: "--spacing-800",
    friendly: "Spacing 800",
    javascript: "spacing_800",
    name: "spacing-800",
    pixel_value: "64px",
    pixel_value_unitless: "64",
    scss: "spacing(800)",
    system: "800",
    type: "spacing",
    value: "4rem",
  },
  {
    category: "spacing",
    css: "--spacing-850",
    friendly: "Spacing 850",
    javascript: "spacing_850",
    name: "spacing-850",
    pixel_value: "96px",
    pixel_value_unitless: "96",
    scss: "spacing(850)",
    system: "850",
    type: "spacing",
    value: "6rem",
  },
  {
    category: "spacing",
    css: "--spacing-900",
    friendly: "Spacing 900",
    javascript: "spacing_900",
    name: "spacing-900",
    pixel_value: "160px",
    pixel_value_unitless: "160",
    scss: "spacing(900)",
    system: "900",
    type: "spacing",
    value: "10rem",
  },
];
